export const TargetFOETypes = {
  ENEMY: 20,
  FRIENDLY: 21,
  PASS: 22,
  UNKNOWN: 23,
};

export const ShowNumberModes = {
  NONE: 0,
  TRACK: 1,
  SYNTH: 2,
};

export const SpeedUnits = {
  KNOTS: 0,
  KMH: 1,
  MPH: 2,
};